import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Services from '../pages/services/page';
import About from '../pages/about/page';
import Location from '../pages/location/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/miami',
    element: <Location />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
